<footer fxLayout="row" fxLayout.lt-sm="column-reverse" fxLayoutAlign="space-between" fxLayoutGap="10px">
    <p class="mat-caption">© 2022 BeyondReps Inc (DBA IronRod Health). All rights reserved. v#.#.#</p>

    <div>
        <a class='footer-link mat-button' href='/legal/termsofservice'>Terms of Service</a>
        <a class='footer-link mat-button' href='/legal/privacynotice'>Privacy Notice</a>
        <a class='footer-link mat-button' href='/legal/cookiepolicy'>Cookie Policy</a>
        <a class='footer-link mat-button' href='/legal/ccpa'>CCPA</a>
    </div>
</footer>